import axios from 'axios'

export default {
  namespaced: true,
  state: {
    workDocsDocumentTypeGrid: [],
    workDocsDocumentTypeAll: [],
    workDocsDocumentTypeShow: null,
    pageData: null,
  },
  mutations: {
    setWorkDocsDocumentTypeGrid(state, payload) {
      state.workDocsDocumentTypeGrid = payload
    },
    setWorkDocsDocumentTypeAll(state, payload) {
      state.workDocsDocumentTypeAll = payload
    },
    setWorkDocsDocumentTypeShow(state, payload) {
      state.workDocsDocumentTypeShow = payload
    },
    setPageData(state, payload) {
      state.pageData = payload
    },
  },
  getters: {
    workDocsDocumentTypeGrid: (state) => {
      return state.workDocsDocumentTypeGrid
    },
    workDocsDocumentTypeAll: (state) => {
      return state.workDocsDocumentTypeAll
    },
    workDocsDocumentTypeShow: (state) => {
      return state.workDocsDocumentTypeShow
    },
    pageData: (state) => {
      return state.pageData
    },
  },
  actions: {
    onWorkDocsDocumentTypeGrid({ commit, rootState }, { limit, page, sort, search }) {
      commit('setLoadingAnimation', true, { root: true })
      let url =
        rootState.apiDomain + '/api/admin/work/document-type/grid?limit=' + limit + '&page=' + page
      if (sort) {
        url = url + '&order[]=' + sort.param + ':' + sort.value
      } else {
        url = url + '&order[]=name:asc'
      }
      if (search) url = url + '&search=' + search
      return new Promise((resolve, reject) => {
        axios({
          url,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkDocsDocumentTypeGrid', resp.data.data)
            commit('setPageData', resp.data)
            commit('setLoadingAnimation', false, { root: true })
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimation', false, { root: true })
            reject(err)
          })
      })
    },
    onWorkDocsDocumentTypeAll({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/work/document-type/grid?limit=0' +
            '&order[]=name:asc',
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkDocsDocumentTypeAll', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkDocsDocumentTypeShow({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/document-type/' + id + '&order[]=name:asc',
          id: id,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkDocsDocumentTypeShow', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkDocsDocumentTypeCreate({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/document-type',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkDocsDocumentTypeUpdate({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/document-type',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkDocsDocumentTypeDelete({ rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/document-type/' + id,
          id: id,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
